export const INVESTOR_TYPE_OPTIONS = [
  { id: 'private', name: 'Private Investor' },
  { id: 'institutional', name: 'Institutional Investor' },
  { id: 'corporate', name: 'Corporate Investor' },
  { id: 'family-office', name: 'Family Office' },
  { id: 'other', name: 'Other' },
]

export const SLIDE_READY_TIMEOUT = 100
